import axios from 'axios'
import Store from '@/store/store'

const loggedInCookieKey = '_loggedIn'
const returnUrlKey = '_forceRedirectUrl'

const AuthenticationService = {
  isLoginPageRedirect: false,
  async logout() {
    try {
      const response = await axios.get('/logout', {
        fromURI: location.href,
      })
      // redirect to the okta logout page
      location.href = response.data
    } catch (e) {
      location.reload()
    }
  },
  async login() {
    if (this.isLoginPageRedirect) return false
    this.isLoginPageRedirect = true

    const response = await axios.get(
      `/LoginUrl?returnUrl=${encodeURIComponent(location.pathname + location.search)}`
    )
    location.href = response.data
  },
  isAccessableAnonimously() {
    return window.location.pathname == '/unsuccessful-login-page'
  },
  async setCurrentUser() {
    try {
      if (this.isAccessableAnonimously()) return true

      const userResponse = await axios.get('/currentuser')
      Store.commit('user/setCurrentUser', userResponse.data)

      if (!userResponse.data) {
        await this.login()
        return false
      }

      // The /api/cst pass-through, but on the default instance with only baseURL overridden.
      // Importing passThroughAxios here would create an import cycle: its error interceptor
      // imports this service. The default instance carries the same interceptor (main.js).
      const dealerSettingsResponse = await axios.get('dealer-settings', { baseURL: '/api/cst/' })
      Store.commit('user/setDealerSettings', dealerSettingsResponse.data)

      return true
    } catch (e) {
      return Promise.reject(e)
    }
  },
}

export default AuthenticationService
